export default __webpack_public_path__ + "static/media/affari-regolatori.d1080ab3.jpg";